import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from './components/AuthGuard';
import { currentUser } from './lib/auth';
import CampaignsList from './pages/CampaignsList';
import CampaignForm from './pages/CampaignForm';
import CampaignView from './pages/CampaignView';
import CampaignRecommendations from './pages/CampaignRecommendations';
import Clients from './pages/Clients';
import ClientForm from './pages/ClientForm';
import Destinations from './pages/Destinations';
import DestinationForm from './pages/DestinationForm';
import DestinationView from './pages/DestinationView';
import Reports from './pages/Reports';
import FraudGuard from './pages/FraudGuard';
import Settings from './pages/Settings';
import Dashboard from './pages/Dashboard';
import Metrics from './pages/Metrics';
import Finance from './pages/Finance';
import Billing from './pages/Billing';
import Implementation from './pages/Implementation';
import Docs from './pages/Docs';
import Debug from './pages/Debug';
import Placeholder from './pages/Placeholder';
import AuthCallback from './pages/AuthCallback';

function Protected({ element }: { element: React.ReactNode }) {
  return <AuthGuard>{element}</AuthGuard>;
}

/** Rota só para admin — cliente (não-admin) é redirecionado para as campanhas. */
function AdminOnly({ element }: { element: React.ReactNode }) {
  return (
    <AuthGuard>
      <AdminGate>{element}</AdminGate>
    </AuthGuard>
  );
}
// currentUser() lê o token da sessão; dentro do AuthGuard ele já existe.
function AdminGate({ children }: { children: React.ReactNode }) {
  return currentUser()?.isAdmin ? <>{children}</> : <Navigate to="/campaigns" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback />} />

      <Route path="/" element={<Navigate to="/campaigns" replace />} />
      <Route path="/campaigns" element={<Protected element={<CampaignsList />} />} />
      <Route path="/campaigns/new" element={<Protected element={<CampaignForm />} />} />
      <Route path="/campaigns/edit/:id" element={<Protected element={<CampaignForm />} />} />
      <Route path="/campaigns/view/:id" element={<Protected element={<CampaignView />} />} />
      <Route path="/campaigns/recommendations/:id" element={<Protected element={<CampaignRecommendations />} />} />
      <Route path="/dashboard" element={<AdminOnly element={<Dashboard />} />} />
      <Route path="/metrics" element={<AdminOnly element={<Metrics />} />} />
      <Route path="/destinations" element={<Protected element={<Destinations />} />} />
      <Route path="/destinations/new" element={<Protected element={<DestinationForm />} />} />
      <Route path="/destinations/edit/:id" element={<Protected element={<DestinationForm />} />} />
      <Route path="/destinations/view/:id" element={<Protected element={<DestinationView />} />} />
      <Route path="/reports" element={<AdminOnly element={<Reports />} />} />
      <Route path="/clients" element={<AdminOnly element={<Clients />} />} />
      <Route path="/clients/new" element={<AdminOnly element={<ClientForm />} />} />
      <Route path="/clients/edit/:id" element={<AdminOnly element={<ClientForm />} />} />
      <Route path="/finance" element={<AdminOnly element={<Finance />} />} />
      <Route path="/billing" element={<Protected element={<Billing />} />} />
      <Route path="/fraud-guard" element={<AdminOnly element={<FraudGuard />} />} />
      <Route path="/implementation" element={<AdminOnly element={<Implementation />} />} />
      <Route path="/debug" element={<AdminOnly element={<Debug />} />} />
      <Route path="/docs" element={<AdminOnly element={<Docs />} />} />
      <Route path="/settings" element={<AdminOnly element={<Settings />} />} />
      <Route path="*" element={<Protected element={<Placeholder title="Not found" />} />} />
    </Routes>
  );
}
